import { useLocation } from "react-router-dom";
import { Icon } from "@/components/ui/Icon";
import { useSpace } from "@/hooks/useSpace";
import { menuKeyOfPath } from "@/domain/menus";

/**
 * 경원 아스콘에서 OKIS 미러(경원 자료)로 연결된 화면 — 안내 띠를 띄우지 않는다(2026-10-22).
 * 홈은 경원 자료가 있는 위젯만 보인다(나머지는 경원 홈에서 숨김, Dashboard AVAILABLE_WIDGETS ascon).
 */
const ASCON_CONNECTED_MENUS: readonly string[] = ["dashboard", "dispatch-view", "shipment-stats"];

/**
 * SpaceBanner — 경원산업 공간 공통 안내 띠 (B′ 미리보기).
 * 경원 자료가 연결되지 않은 화면은 실제로 중앙산업 자료를 보여 준다 — 그 화면에서만 띄운다.
 * 보이는 조건: space === "gyeongwon" 이고, 경원 아스콘 연결 화면(홈·출하조회·출하실적)이 아닐 때.
 */
export function SpaceBanner() {
  const { space, biz } = useSpace();
  const { pathname } = useLocation();
  if (space !== "gyeongwon") return null;
  if (biz === "ascon" && ASCON_CONNECTED_MENUS.includes(menuKeyOfPath(pathname))) return null;
  return (
    <div className="space-banner is-space-gyeongwon" role="status">
      <Icon name="info" size={16} />
      <strong>경원 데이터 미연결</strong>
      <span className="space-banner-sub">이 화면의 내용은 중앙산업 자료입니다. 경원산업 자료는 아직 연결되지 않았습니다.</span>
    </div>
  );
}
